import { State } from '../../../reducer';
import { namespace } from './index';
import { createSelector } from 'reselect';

const getPayoutRulesSelectorState = (state: State) => state[namespace];

export const getPayoutRulesSelector = createSelector([getPayoutRulesSelectorState], (s) => s);
